import { toMinutes } from './travelLegs';

/**
 * Builds a map of lodging check-in/check-out events keyed by "date_destinationId".
 * Extracted from the identical useMemo blocks in Itinerary.js and ItineraryDayView.js.
 *
 * @param {Array} lodgings
 * @returns {Object} map of dateDestKey → sorted array of lodging event rows
 */
export function buildLodgingEventsByDateDest(lodgings) {
  const m = {};

  (Array.isArray(lodgings) ? lodgings : []).forEach((l) => {
    const destId = l?.destination_id;
    if (!destId) return;

    const destKey = String(destId);
    const lodgingId = String(l?.lodging_id || '').trim();
    const name = String(l?.lodging_name || '').trim() || 'Lodging';
    const checkIn = String(l?.check_in_time || '').trim();
    const checkOut = String(l?.check_out_time || '').trim();
    const startDate = String(l?.start_date || '').slice(0, 10);
    const endDate = String(l?.end_date || '').slice(0, 10);

    if (startDate) {
      const k = `${startDate}_${destKey}`;
      if (!m[k]) m[k] = [];
      m[k].push({
        row_kind: 'lodging',
        row_id: `lodging-${l?.lodging_id || name}-in-${startDate}`,
        title: 'Check-in',
        start_local: checkIn,
        lodging_id: lodgingId,
        destination_id: destId,
      });
    }

    if (endDate) {
      const k = `${endDate}_${destKey}`;
      if (!m[k]) m[k] = [];
      m[k].push({
        row_kind: 'lodging',
        row_id: `lodging-${l?.lodging_id || name}-out-${endDate}`,
        title: 'Check-out',
        start_local: checkOut,
        lodging_id: lodgingId,
        destination_id: destId,
      });
    }
  });

  Object.keys(m).forEach((k) => {
    m[k].sort((a, b) => {
      const am = toMinutes(a.start_local);
      const bm = toMinutes(b.start_local);
      if (am == null && bm == null) return 0;
      if (am == null) return 1;
      if (bm == null) return -1;
      return am - bm;
    });
  });

  return m;
}
